import anime from 'animejs';

interface IScrollProps {
  easingFn?: [string, number?] | null;
  scrollContainer?: HTMLElement;
}

/**
 * 주어진 Y축 좌표로 부드럽게 스크롤한다. 중간에 사용자가 터치나 휠을 사용하면 취소한다.
 *
 * @param to 목표 스크롤 지점.
 */
export function scrollWithAnim(to: number, props?: IScrollProps): void {
  let animation: anime.AnimeInstance | undefined = undefined;

  const [easing, duration] = props?.easingFn || ['spring(1, 40, 100, 0)'];

  const eventTarget = props?.scrollContainer || window;
  const pos = props?.scrollContainer?.scrollTop ?? window.pageYOffset;
  const targets = { pos };

  function cancel(): void {
    animation?.pause();
    anime.remove(targets);

    detach();
  }

  function detach(): void {
    eventTarget.removeEventListener('wheel', cancel);
    eventTarget.removeEventListener('touchstart', cancel);
  }

  animation = anime({
    targets,
    duration,
    easing,
    pos: to,
    begin: () => {
      eventTarget.addEventListener('wheel', cancel);
      eventTarget.addEventListener('touchstart', cancel);
    },
    change: (anim: anime.AnimeInstance) => {
      const currentPos = anim.animations[0]['currentValue'];

      props?.scrollContainer ? (props.scrollContainer.scrollTop = currentPos) : window.scrollTo(0, currentPos);
    },
    changeComplete: () => {
      !props?.scrollContainer && window.scrollTo(0, to);
    },
    complete: detach,
  });
}
